<app-title-bar rootBreadCrumbs="['i18n.core.navigation.export-configuration']" titleText="i18n.core.navigation.fieldValueReplacements"></app-title-bar>
<div class="row grow w-100">
  <div class="col-3">
    <app-field-value-replacements-client-selector (selectedClientChange)="onClientSelected($event)"></app-field-value-replacements-client-selector>
  </div>
  @if (selectedGridClient()) {
    <div class="col-9 h-100">
      <app-field-value-replacement-details [selectedGridClient]="selectedGridClient()" (allClientReplacementsDeleted)="onClientReplacementsDeleted()"></app-field-value-replacement-details>
    </div>
  }
</div>
